import React, { useEffect, useState } from 'react';
import CampaignDaysPlay from '../../CampaignDaysPlay/CampaignDaysPlay.jsx';
import Regions from '../../Regions/Regions.jsx';
import OutdoorImpactRegionsTable from '../../OutdoorImpact/OutdoorImpactRegionsTable.jsx';
import styles from '../CampaignDetails.module.css';
import Environment from '../../Environment/Environment.jsx';
import { CAMPAIGN_STATUS } from '../../../../constants/enums.js';
import campaignValues from '../../../../utils/campaignValues.js';

const NorwayCampaignView = ({ originalOrderlinesData, filteredOrderlinesData, campaignPromiseType, campaignType, showDaysGraph, orderOrderLines}) => {
  const [campaignStatus, setCampaignStatus] = useState(CAMPAIGN_STATUS.NOT_STARTED);
  const [showOITable, setShowOITable] = useState(false);
  const [filterAllData, setFilterAllData] = useState(false);
  const [useOriginalRegionHeader, setUseOriginalRegionHeader] = useState(false);
  const regionVACHeaderText = 'Regions - VAC/VI';
  const regionHOHeaderText = 'Regions - Reach/Frequency';
  const footerNote = '* Please note that the graphs always represent the total campaign delivery across the entire period. The date filter applies only to the “Campaign data” section.';

  useEffect(() => {
    if (!orderOrderLines) return;

    if (orderOrderLines.length > 0) {
        const metadata = orderOrderLines[0];
        const calculatedStatus = campaignValues.campaignStatus(
            metadata.periodStart,
            metadata.periodEnd
        );
        setCampaignStatus(calculatedStatus);
    }
  }, [orderOrderLines]);

  useEffect(() => {
    if (!campaignPromiseType) return;
    
    switch (campaignPromiseType.toLowerCase()) {
      case 'npc':
      case 'ncpf':
      case 'npv':
      case 'npvf':
      case 'npp':
        setFilterAllData(true);
        break;
      default:  
        setFilterAllData(false);
        break;
    }

    switch (campaignPromiseType.toLowerCase()) {
      case 'npc':
      case 'ncpf':
      case 'npv':
      case 'npvf':
      case 'npp':      
      case 'npp2':        
        setUseOriginalRegionHeader(true);
        break;
      default:  
        setUseOriginalRegionHeader(false);
        break;
    }

    switch (campaignPromiseType.toLowerCase()) {
      case 'nsv':
      case 'npv2': 
        setShowOITable(true);
        break;
      default:  
        setShowOITable(false);
        break;
    }
  }, [campaignPromiseType]);

  return (
    <>
      {showDaysGraph && (
        <div className={styles.chartCampaignDaysPlay}>
          <CampaignDaysPlay 
            orderlinesData={filterAllData ? filteredOrderlinesData : originalOrderlinesData} 
            campaignPromiseType={campaignPromiseType} />
          {!filterAllData && (
            <div className={styles.footerNote}>{footerNote}</div>
          )}
        </div>
      )}
      {showDaysGraph ? (
        <div className={styles.twoChartRow}>
          <Regions
            orderlinesData={filterAllData ? filteredOrderlinesData : originalOrderlinesData}
            campaignPromiseType={campaignPromiseType}
            campaignType={campaignType}
            showDaysGraph={showDaysGraph}
            regionHeaderText={useOriginalRegionHeader ? null : regionVACHeaderText}
            alignWithFooterNote={!filterAllData}
          />
          {showOITable ? (
            <div className={styles.chartShadow}>
              <div className={styles.graphLabel}>
                <h4>{regionHOHeaderText}</h4>
              </div>
              <OutdoorImpactRegionsTable 
                orderOrderLineId={orderOrderLines ? orderOrderLines[0]?.id : -1} 
                campaignStatus={campaignStatus}
                alignWithFooterNote={!filterAllData} 
              />
            </div>
          ) : (
            <Environment
              orderlinesData={filterAllData ? filteredOrderlinesData : originalOrderlinesData}
              campaignPromiseType={campaignPromiseType}
              campaignType={campaignType}
              showDaysGraph={showDaysGraph}
              alignWithFooterNote={!filterAllData}
            />
          )}
          {!filterAllData && (
            <div className={styles.twoChartRowFooter + ' ' + styles.footerNote}>{footerNote}</div>
          )}
          </div>
      ) : (
        <>
          <div className={styles.regionBlock}>
            <Regions
              orderlinesData={filterAllData ? filteredOrderlinesData : originalOrderlinesData}
              campaignPromiseType={campaignPromiseType}
              campaignType={campaignType}
              showDaysGraph={showDaysGraph}
              regionHeaderText={useOriginalRegionHeader ? null : regionVACHeaderText}
            />
            {!filterAllData && (
              <div className={styles.footerNote}>{footerNote}</div>
            )}
          </div>
          {showOITable ? (
            <div className={styles.chartShadow + ' ' + styles.chartBelow}>
              <div className={styles.graphLabel}>
                <h4>{regionHOHeaderText}</h4>
              </div>
              <OutdoorImpactRegionsTable 
                orderOrderLineId={orderOrderLines ? orderOrderLines[0]?.id : -1} 
                campaignStatus={campaignStatus} 
              />
            </div>
          ) : (
            <div className={styles.chartBelow}>
              <Environment
                orderlinesData={filterAllData ? filteredOrderlinesData : originalOrderlinesData}
                campaignPromiseType={campaignPromiseType}
                campaignType={campaignType}
                showDaysGraph={showDaysGraph}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default NorwayCampaignView;
